app.controller('exportLogController', ['$rootScope', '$scope', '$state', '$stateParams', '$mdDialog', '$translate', 'objectHelper',
    'baseModel', 'applicationModel', 'userModel', 'exportLogEntryModel', 'fileUploadModel', 'attachmentFileModel',
    function ($rootScope, $scope, $state, $stateParams, $mdDialog, $translate, objectHelper, baseModel, applicationModel,
              userModel, exportLogEntryModel, fileUploadModel, attachmentFileModel) {

        var listeners = {};

        function setData() {
            $scope.exportLogs = [];
            $scope.criteria = new EsDataGridCriteria();
            $scope.criteria.patientId = $stateParams.patientId;
            $scope.criteria.pageNumber = 0;
            $scope.numberOfPages = null;
            $scope.rows = $scope.criteria.rowsPerSheet;

            $scope.display = {
                page: 1
            }

        }

        function setPermissions() {

        }

        function setListeners() {

            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });

            listeners.onExportDataPage = function(dataPage) {
                $scope.exportLogs = dataPage.data;
                $scope.numberOfPages = dataPage.numberOfPages;
            };

            listeners.onFileUpload = function(exportLog, attachmentFile) {
                var attachment = new AttachmentVO();
                attachment.name = attachmentFile.fileName;
                attachment.attachmentFiles = [attachmentFile];

                exportLog.receipt = attachment;

                exportLogEntryModel.update(exportLog).then($scope.getData);
            };

        }

        function setActions() {

            $scope.enclose = function (fileInput, exportLog) {
                if(fileInput.length > 0) {
                    fileInput.forEach(function (file) {
                        fileUploadModel.uploadExport({data:file}).then(listeners.onFileUpload.bind(null, exportLog))
                    });
                }
            };

            $scope.downloadReceipt = function(logExport) {
                exportLogEntryModel.downloadReceipt(logExport.id);
            };

            $scope.downloadExportAttachment = function(logExport) {
                attachmentFileModel.download(logExport.receipt.attachmentFiles[0].id);
            };

            $scope.downloadFiles = function(logExport) {
                exportLogEntryModel.downloadFile(logExport.id);
            };


            $scope.criteriaChanged = function (page) {

                $scope.criteria.pageNumber = page - 1;
                $scope.display.page = page;


                if($scope.rows != $scope.criteria.rowsPerSheet) {
                    $scope.criteria.pageNumber = 0;
                    $scope.display.page = 1;
                    $scope.rows = $scope.criteria.rowsPerSheet;
                }
                $scope.getData();
            };

            $scope.getTotal = function () {
                return $scope.numberOfPages * $scope.criteria.rowsPerSheet;
            };

            $scope.getPage = function () {
                $scope.criteria.pageNumber += 1;
                return $scope.criteria.pageNumber ;
            };

            $scope.userHasRightToDownloadExportLog = function(exportLog) {

                return userModel.userHasRight(Constant.RIGHT.EXPORT_MODULE_DOWNLOAD) && exportLog && (exportLog.generationStatus === Enum.GENERATION_STATUS.COMPLETED);
            };

            $scope.getData = function() {
                exportLogEntryModel.getDataPage($scope.criteria).then(listeners.onExportDataPage);
            }
        }

        function configureInterface() {

        }

        function initialize() {
            applicationModel.viewReady = true;
            $scope.getData();
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);